import { Row, SortingFn } from "@tanstack/react-table";
import { IExtendedSearchItem } from "src/api/client/extended-search.api.types";
import { SortDirection } from "src/constants/sort-direction";
import { EnumFigureType, IFigure } from "src/types/common";

export const parseFigureNumericValue = (figure: IFigure | undefined): number | null => {
    if (!figure) {
        return null;
    }

    if (figure.type === EnumFigureType.Date) {
        const dateString = figure.date ?? figure.creationDate;
        if (!dateString) {
            return null;
        }
        return new Date(dateString).getTime();
    }

    if (figure.value === null || figure.value === "") {
        return null;
    }

    const parsed = Number.parseFloat(String(figure.value).replace(",", "."));
    return Number.isNaN(parsed) ? null : parsed;
};

export const figureSortingFn: SortingFn<IExtendedSearchItem> = (rowA, rowB, columnId) => {
    const valueA = parseFigureNumericValue(rowA.getValue<IFigure | undefined>(columnId));
    const valueB = parseFigureNumericValue(rowB.getValue<IFigure | undefined>(columnId));

    if (valueA === null && valueB === null) {
        return 0;
    }

    // TanStack Table inverts the comparator result for descending sorts, this ensures nulls are always last
    const isSortedDesc =
        rowA
            .getAllCells()
            .find(cell => cell.column.id === columnId)
            ?.column.getIsSorted() === SortDirection.Descending;

    if (valueA === null) {
        return isSortedDesc ? -1 : 1;
    }
    if (valueB === null) {
        return isSortedDesc ? 1 : -1;
    }

    return valueA - valueB;
};

export const traderSortingFn: SortingFn<IExtendedSearchItem> = (rowA: Row<IExtendedSearchItem>, rowB: Row<IExtendedSearchItem>) => {
    const nameA = rowA.original.wikifolioShortDescription?.toLowerCase() ?? "";
    const nameB = rowB.original.wikifolioShortDescription?.toLowerCase() ?? "";
    return nameA.localeCompare(nameB);
};
